import { render, staticRenderFns } from "./SampleTypeDetail.vue?vue&type=template&id=6c504623"
import script from "./SampleTypeDetail.vue?vue&type=script&lang=js"
export * from "./SampleTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports